module.exports = __webpack_public_path__ + "static/media/17.469c3d60.gif";